import { TextField, Checkbox } from '@mui/material';
import Autocomplete, { AutocompleteProps } from '@mui/material/Autocomplete';
import {
  CheckBoxOutlinedIcon,
  CheckBoxOutlinedBlankIcon,
} from '../../controls/MaterialUIIcons';

const icon = <CheckBoxOutlinedBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxOutlinedIcon fontSize="small" />;

type MultiSelectProps<T> = Omit<
  AutocompleteProps<T, true, undefined, undefined>,
  | 'renderOption'
  | 'renderInput'
  | 'multiple'
  | 'disableCloseOnSelect'
  | 'getOptionLabel'
> & {
  label: string;
  error: string;
  required?: boolean;
  getOptionLabel(option: T): string;
};
export default function MultiSelect<T>(props: MultiSelectProps<T>) {
  const {
    label,
    error, // TODO
    required,
    ...other
  } = props;

  return (
    <Autocomplete
      {...other}
      multiple
      disableCloseOnSelect
      renderOption={(prop, option, { selected }) => (
        <>
          <Checkbox
            sx={{ mt: 0, mb: 0, pt: 0, pb: 0}}
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {other.getOptionLabel(option)}
        </>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={props.label}
          required={required}
          error={!!error}
          fullWidth
        />
      )}
    />
  );
}
